module.exports = __webpack_public_path__ + "img/20251215-173624.f68f125e.gif";